import type { ComponentProps, FC } from 'react'
import MasonryBase, {
  ResponsiveMasonry as ResponsiveMasonryBase,
} from 'react-responsive-masonry'

/**
 * The bundled types in react-responsive-masonry@2.7.2 incorrectly declare
 * `gutterBreakPoints` values as `number`, but the component expects CSS
 * length strings (e.g. "1rem") at runtime. This wrapper corrects the type
 * in a single place so call sites can keep passing string gutters.
 */
type CorrectedResponsiveMasonryProps = Omit<
  ComponentProps<typeof ResponsiveMasonryBase>,
  'gutterBreakPoints'
> & {
  gutterBreakPoints?: Record<number, string>
}

export const ResponsiveMasonry =
  ResponsiveMasonryBase as unknown as FC<CorrectedResponsiveMasonryProps>

export default MasonryBase
